import React, { useMemo } from 'react';
import classes from './style.module.scss';
import {IssueDetails, ServiceDetails, WorkDetails} from "~/types";
import useTranslation from "~/app/hooks/useTranslation";
import {PERMISSION_GROUPS} from "~/accessControl/permissionGroups";
import AccessControl from "~/accessControl";
import { ServiceStatuses } from '~/app/data/statuses/services';
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import { IssueStatuses } from '~/app/data/statuses/issue';

export interface WorkOrderProps {
    status: IssueDetails['status'] | ServiceDetails['status']
    workDetails: WorkDetails
    type: IssueOrServiceType
}

export type ListComponent = React.FC<WorkOrderProps>

const List: ListComponent = ({status, workDetails, type}) => {
    const {t} = useTranslation("issue");
    const checkCompleted = useMemo(() => {
        return type === IssueOrServiceType.ISSUE
            ? status === IssueStatuses.COMPLETED || status === IssueStatuses.CLOSED
            : status === ServiceStatuses.COMPLETED || status === ServiceStatuses.PARTIALLLYCOMPLETED || status === ServiceStatuses.CANCELLED
    }, [type, status])

    const content = (
        <div className={classes['order-time-entry']}>
            <div className={classes['time-and-name']}>
                <span className={classes['time']}>{t("workDate", {date: workDetails.date})}</span>
                <span className={classes['name']}>{workDetails.name}</span>
            </div>
            <div className={classes['comment']}>{workDetails.comment}</div>
            <div className={classes['hours-cost']}>
                <span className={classes['hours']}>{workDetails.hours}</span>
                <span className={classes['cost']}>{workDetails.cost}</span>
            </div>
        </div>
    );

    if (checkCompleted) {
        return type === IssueOrServiceType.ISSUE ? (
            <AccessControl requiredPermissions={PERMISSION_GROUPS.readCompletedWorkOrderDetails}>
                {content}
            </AccessControl>
        ) : content;
    }

    return content;
};

export default List
